import React from "react";
import { FaHome, FaChartBar, FaExchangeAlt, FaRegCircle, FaWallet } from "react-icons/fa";
import "./MyPage.css";

const BottomTabs = ({ active = "Home", onTab }) => {
  const tabs = [
    { label: "Home", icon: <FaHome />, path: "/home" },
    { label: "Markets", icon: <FaChartBar />, path: "/markets" },
    { label: "Trade", icon: <FaExchangeAlt />, path: "/trade" },
    { label: "ALEX", icon: <FaRegCircle />, path: "/aiex" },
    { label: "Balance", icon: <FaWallet />, path: "/balance" },
  ];

  return (
    <div className="bottom-tabs">
      {tabs.map((t) => (
        <div
          key={t.label}
          className={`bottom-tab-item ${active === t.label ? "active" : ""}`}
          onClick={() => onTab(t.path)}
        >
          <div className="bottom-tab-icon">{t.icon}</div>
          <div className="bottom-tab-title">{t.label}</div>
        </div>
      ))}
    </div>
  );
};

export default BottomTabs;